
import type { Article } from "@/types/article";

/**
 * Maps a raw Supabase "articles" record to the local Article type.
 */
export function mapSupabaseArticleToArticle(data: any): Article {
  return {
    id: data.id,
    title: data.title,
    description: data.description || "No description available",
    category: data.category || "Uncategorized",
    premium: !!data.premium,
    readTime: data.read_time || "5 min read",
    date: data.date
      ? new Date(data.date).toLocaleDateString()
      : new Date().toLocaleDateString(),
    image: data.image || "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
    status: data.status || "draft",
    author: data.author || "AI Team",
    views: typeof data.views === "number" ? data.views : 0,
  };
}
